module.exports = "<div [ngClass]=\"{'publishing': publishing}\" #publisherDiv></div>\n"